import {create_staff, delete_staff, query_staff_list, recover_staff, update_staff,} from '@/api/mjstore-model';
import {TableColumn} from '@/typing';
import {Record, SearchConfig} from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import {STORAGE_CURRENT_ORG_KEY} from '@/store/mutation-type';
import {
  btn_list,
  config,
  event_obj,
  head_btn_list,
  slotList,
} from '@/components/page-model/mjstore/mjstore-staff-config';

import {reactive,ref} from 'vue';
import {get_gender, get_is_active, get_is_active2, getDate} from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '员工编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写员工编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '员工姓名',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写员工姓名',
    },
    {
      type: 'input',
      name: 'phone',
      label: '员工手机号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写员工手机号',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '所属门店',
      disabled: false,
      placeholder: '请选择隶属门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'select',
      name: 'include_left',
      label: '是否包括离职',
      labelKey: 'name',
      valueKey: 'value',
      disabled: false,
      placeholder: '请选择是否包括离职',
      allowClear: true,
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    phone: null,
    shop_id: null,
    code: null,
    include_left: false,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    {
      value: True,
      name: '可用',
    },
    { value: False, name: '作废' },
  ],
  include_left: [
    {
      value: True,
      name: '是',
    },
    { value: False, name: '否' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '员工姓名',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写员工姓名',
    },
    {
      type: 'remoteselect',
      name: 'title_id',
      label: '职位',
      disabled: false,
      valueKey: 'id',
      labelKey: 'name',
      placeholder: '请选择职位',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-stafftitle',
    },
    {
      type: 'datepicker',
      name: 'join_date',
      label: '入职日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      format: 'YYYY-MM-DD',
      valueFormat: 'YYYY-MM-DD',
      placeholder: '请填写入职日期',
    },
    {
      type: 'radio',
      name: 'gender',
      label: '性别',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择性别',
    },
    {
      type: 'input',
      name: 'phone',
      label: '员工手机号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写员工手机号',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '登录账号',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择登录账号',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '所属门店',
      disabled: false,
      placeholder: '请选择所属门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'datepicker',
      name: 'left_date',
      label: '离职日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      format: 'YYYY-MM-DD',
      valueFormat: 'YYYY-MM-DD',
      placeholder: '请填写入职日期',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入员工姓名' }],
    join_date: [{ required: true, message: '请填输入入职日期' }],
    phone: [{ required: true, pattern: /^1[3456789]\d{9}$/, message: '请填输入员工正确手机号' }],
    shop_id: [{ required: true, message: '请填输入隶属门店' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    title_id: null,
    join_date: null,
    gender: null,
    phone: null,
    shop_id: null,
    left_date: null,
  }),
};
const edit_model_config_options = {
  gender: [
    { value: 0, name: '女' },
    { value: 1, name: '男' },
  ],
};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '员工姓名',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写员工姓名',
    },
    {
      type: 'remoteselect',
      name: 'title_id',
      label: '职位',
      disabled: false,
      valueKey: 'id',
      labelKey: 'name',
      placeholder: '请选择职位',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-stafftitle',
    },
    {
      type: 'datepicker',
      name: 'join_date',
      label: '入职日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      format: 'YYYY-MM-DD',
      valueFormat: 'YYYY-MM-DD',
      placeholder: '请填写入职日期',
    },
    {
      type: 'radio',
      name: 'gender',
      label: '性别',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择性别',
    },
    {
      type: 'input',
      name: 'phone',
      label: '员工手机号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写员工手机号',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '登录账号',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择登录账号',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '所属门店',
      disabled: false,
      placeholder: '请选择所属门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'datepicker',
      name: 'left_date',
      label: '离职日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      format: 'YYYY-MM-DD',
      valueFormat: 'YYYY-MM-DD',
      placeholder: '请填写入职日期',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入员工姓名' }],
    join_date: [{ required: true, message: '请填输入入职日期' }],
    phone: [{ required: true, pattern: /^1[3456789]\d{9}$/, message: '请填输入员工正确手机号' }],
    shop_id: [{ required: true, message: '请填输入隶属门店' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    title_id: null,
    join_date: null,
    gender: null,
    phone: null,
    shop_id: null,
    left_date: null,
  }),
};
const update_model_config_options = {
  gender: [
    { value: 0, name: '女' },
    { value: 1, name: '男' },
  ],
};

const titleList = {
  title: '店员管理',
  addModalTitle: '新建店员',
  updateTitle: '修改店员',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    staff_id: 'id',
  },
  delete: {
    staff_id: 'id',
  },
  recover: {
    staff_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    staff_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '所属门店',
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '员工编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '员工姓名',
    dataIndex: 'name',
    checked: true,
  },

  {
    title: '员工手机号',
    dataIndex: 'phone',
    checked: true,
  },
  {
    title: '性别',
    dataIndex: 'gender',
    checked: true,
    filterMultiple: true,
    filters: [
      { text: '全部', value: '' },
      { text: '女', value: 0 },
      { text: '男', value: 1 },
    ],
    content: (record: any, text: any) => {
      return get_gender(text);
    },
  },
  {
    title: '职位',
    dataIndex: 'title__name',
    checked: true,
  },

  {
    title: '入职日期',
    dataIndex: 'join_date',
    checked: true,

    content: (record: any, text: any) => {
      return getDate(text);
    },
  },
  {
    title: '离职日期',
    dataIndex: 'left_date',
    checked: true,

    content: (record: any, text: any) => {
      return getDate(text);
    },
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push(
  { type: 'custom', slotName: 'gender', field_0: '女', field_1: '男' },
  {
    type: 'custom',
    // slotName: 'is_active',
    field_true: '可用',
    field_false: '作废',
  },
);

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_staff_list,
    addData: create_staff,
    updateData: update_staff,
    removeData: delete_staff,
    recoverData: recover_staff,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
